import React from 'react';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { getProjectCommentThread } from '@/services/comments';
import { useAsyncState } from '@/utils/hooks';
import theme from './ProjectMessageThread.module.scss';
import { CommentThreadWrapper } from '@/components/Comments/CommentThreadWrapper';

interface ProjectMessageThreadProps {
    projectId: number;
}

const ProjectMessageThread: React.FC<ProjectMessageThreadProps> = ({ projectId }) => {
    const [projectThread] = useAsyncState(() => getProjectCommentThread(projectId), [projectId], null);

    return (
        <div className={theme.thread}>
            {projectThread ? <CommentThreadWrapper threadId={projectThread.threadId} /> : <LoadingIndicator />}
        </div>
    );
};

export default ProjectMessageThread;
